import axios from 'axios'
import { ElNotification , ElMessageBox, ElMessage, ElLoading } from 'element-plus'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from '@/utils/ruoyi'
import cache from '@/plugins/cache'
import { saveAs } from 'file-saver'
import useUserStore from '@/store/modules/user'

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: import.meta.env.VITE_APP_BASE_API,
  // 超时
  timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken()
    config.headers['deptId'] = sessionStorage.getItem('deptId')
  }
  
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    config.params = {};
    config.url = url;
  }
  
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    // 1. 统一处理请求数据，确保格式一致
    let requestData = typeof config.data === 'object' 
      ? JSON.stringify(config.data, Object.keys(config.data || {}).sort()) // 排序键名，确保顺序一致
      : config.data;
      
    const requestObj = {
      url: config.url,
      data: requestData,
      time: new Date().getTime()
    }
    
    // 2. 检查数据大小限制
    const requestSize = new TextEncoder().encode(JSON.stringify(requestObj)).length; // 更准确的字节计算
    const limitSize = 5 * 1024 * 1024; // 5M
    if (requestSize >= limitSize) {
      console.warn(`[${config.url}]: 请求数据大小超出5M限制，无法进行防重复提交验证。`)
      return config;
    }
    
    // 3. 使用更可靠的存储键名，避免冲突
    const cacheKey = `repeat_submit_${config.url}`;
    const sessionObj = cache.session.getJSON(cacheKey);
    
    if (!sessionObj) {
      cache.session.setJSON(cacheKey, requestObj);
    } else {
      const s_url = sessionObj.url;
      const s_data = sessionObj.data;
      const s_time = sessionObj.time;
      const interval = 3000; // 3秒内视为重复提交
      
      // 4. 严格对比请求信息
      if (s_url === requestObj.url && 
          s_data === requestObj.data && 
          requestObj.time - s_time < interval) {
          
        const message = '数据正在处理，请勿重复提交';
        console.warn(`[${s_url}]: ` + message);
        return Promise.reject(new Error(message));
      } else {
        // 更新缓存为最新请求
        cache.session.setJSON(cacheKey, requestObj);
      }
    }
  }
  
  return config;
}, error => {
  console.log(error);
  return Promise.reject(error); // 注意这里需要return
});

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
      return res.data
    }
    if (code === 401) {
      // if (!isRelogin.show) {
        // isRelogin.show = true;
      //   return ElMessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', cancelButtonClass: "colent", confirmButtonClass: "search_for", type: 'warning' }).then(() => {
      //     isRelogin.show = false;
      //     useUserStore().logOut().then(() => {
      //       location.href = '/index';
      //     })
      //     return res.data
      // }).catch(() => {
      //   isRelogin.show = false;
      // });
      // debugger;
       isRelogin.show = false;
       useUserStore().resetToken().then(() => {
          //  location.href = '/index';
          // window.location.href = '/index' // 整页刷新
           if (window.innerWidth < 700) {
            window.location.href = '/supplierMobileLogin';
          } else {
            window.location.href = '/index';
          }
       })
      //  return res.data
    // }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      ElMessage({ message: msg, type: 'error' })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
      ElMessage({ message: msg, type: 'warning' })
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      ElNotification.error({ title: msg })
      return Promise.reject('error')
    } else {
      return  Promise.resolve(res.data)
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    ElMessage({ message: message, type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

// 通用下载方法
export function download(url, params, filename, config) {
  downloadLoadingInstance = ElLoading.service({ text: "正在下载数据，请稍候", background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      ElMessage.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    ElMessage.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}

export default service
